import fetch from 'cross-fetch'
import getApiLocation from './getApiLocation'
import getDefaultHeaders from './getDefaultHeaders'
import validateResult from './validateResult'
import getParameterString from './getParameterString'

const get = (action, { path, parameters }) => {
  const apiLocation = getApiLocation()

  return fetch(`${apiLocation}/${path}${getParameterString(parameters)}`, {
    method: action,
    headers: getDefaultHeaders()
  })
    .then((res) => {
      validateResult(res)
      return res.json()
    })
}

export default get
